export class User {
  constructor(public id = 0, public email = '') {}
}
